import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" {...this.props}><title>Group 24</title><g fill="none" fillRule="evenodd"><circle cx="19" cy="19" r="19" fill="#0084FF" /><path d="M18.9 9C13.431 9 9 13.144 9 18.257c0 2.908 1.434 5.503 3.678 7.2V29l3.378-1.874c.9.252 1.855.388 2.843.388 5.468 0 9.9-4.145 9.9-9.257 0-5.113-4.432-9.257-9.9-9.257zm1.042 12.413l-2.56-2.66-4.931 2.727 5.406-5.736 2.56 2.66 4.93-2.727-5.405 5.736z" fillRule="nonzero" fill="#FFF" /></g></svg>;
  }

}